import { Injectable } from '@angular/core';
import { Http, RequestOptions, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class Api {
    private url = 'https://www.42netmedia.com/api/public/sms';

    constructor(public http: Http) {}

    get = (endpoint: string, params?: any, options?: RequestOptions) => {
        if (!options)
          options = new RequestOptions();

        // Support easy query params for GET requests
        if (params) {
            const p = new URLSearchParams();
            for (const k in params)
              if (params.hasOwnProperty(k))
                p.set(k, params[k]);

            p.set('_', Math.floor(Date.now() / 1000).toString());
            // Set the search field if we have params and don't already have
            // a search field set in options.
            options.search = !options.search && p || options.search;
        }

        return this.http.get(`${this.url}/${endpoint}`, options)
                        .catch(this.handleError);
    };

    post = (endpoint: string, body: any, options?: RequestOptions) => {
        return this.http.post(`${this.url}/${endpoint}`, body, options)
                        .catch(this.handleError);
    };

    put = (endpoint: string, body: any, options?: RequestOptions) => {
        return this.http.put(`${this.url}/${endpoint}`, body, options)
                        .catch(this.handleError);
    };

    delete = (endpoint: string, options?: RequestOptions) => {
        return this.http.delete(`${this.url}/${endpoint}`, options)
                        .catch(this.handleError);
    };

    patch = (endpoint: string, body: any, options?: RequestOptions) => {
        return this.http.put(`${this.url}/${endpoint}`, body, options)
                        .catch(this.handleError);
    };

  private handleError: (error: Response | any) => Observable<any> = (error: Response | any): Observable<any> => {

    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else
      errMsg = error.message ? error.message : error.toString();

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./src/providers/api.service.ts